import { db } from "../firebase"; // Adjust path based on your project
import { collection, doc, getDoc } from "firebase/firestore";

/**
 * Fetches a location document from the "locations" collection by a location ID.
 * @param {number} locationId - The location ID to search for.
 * @returns {Object|null} - The location document data or null if not found.
 */
export const getLocationById = async (locationId) => {
  try {
    // Temporary hardcoded data for testing
    if (locationId === 0) {
      return { name: "JMJ Orlando Clinic", address: "1401 West Colonial Drive, Orlando, FL 32804" };
    }
    if (locationId === 1) {
      return { name: "JMJ Kissimmee Clinic", address: "800 North Rose Avenue, Kissimmee, FL 34741" };
    }

    // The original logic for fetching from Firestore
    const locationRef = doc(db, "locations", String(locationId)); // Ensure it's a string
    const docSnapshot = await getDoc(locationRef);

    if (docSnapshot.exists()) {
      return docSnapshot.data();
    } else {
      console.warn(`Location with ID ${locationId} not found.`);
      return null;
    }
  } catch (error) {
    console.error("Error fetching location:", error);
    throw error;
  }
};
